import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    deposit: {
        id: 'cards.transactions.rows.top_up',
        defaultMessage: 'Card top up',
    },
    payment: {
        id: 'cards.transactions.rows.withdraw',
        defaultMessage: 'Card withdraw',
    },
})
